<div style="display: flex; flex-direction: column; width: 100%; height: 100%">
    <div style="width: 100%; height: 100%">
        <img
            *ngFor="let car of carsUrls"
            [alt]="car.path"
            [class.active]="car.path === (activePath$ | async)"
            [src]="'assets/images/modely-3quarter/' + car.path + '.png'"
            class="car-image"
        />
    </div>
    <div style="display: flex; justify-content: center; z-index: 10">
        <mg-ui-button i18n="@@configurator.interior-view.title" (click)="openInteriorView()"
            >Interior preview</mg-ui-button
        >
    </div>
</div>
